import * as types from "./mutationTypes";

export default {
  [types.CLEAR_CREDITS](state) {
    state.hasError = false;
    state.extraCredits = [];
    state.initialCredits = [];
    state.standardCredits = [];
    state.plan = {};
  },
  [types.SET_ERROR](state, { status }) {
    state.hasError = status;
  },
  [types.SET_EXTRA_CREDITS](state, { extraCredits }) {
    state.extraCredits = extraCredits;
  },
  [types.SET_INITIAL_CREDIT](state, { initialCredits }) {
    state.initialCredits = initialCredits;
  },
  [types.SET_STANDARD_CREDIT](state, { standardCredits }) {
    state.standardCredits = standardCredits;
  },
  [types.SET_LAST_TRANSACTIONS](state, { lastTransactions }) {
    state.lastTransactions = lastTransactions;
  },
  [types.SET_PLAN](state, plan) {
    state.plan = plan;
  },
  [types.CLEAR_PLAN](state) {
    state.plan = {};
  }
};
